import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { RotatingSquare } from "react-loader-spinner";
import OrderList from "./OrderList/OrderList";

const OrderSetEdit = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [updateData, setupdateData] = useState([]);
    const [selectedPlatform, setSelectedPlatform] = useState("");
    const [errorMessage, setErrorMessage] = useState([]);
    const refSubmitDis = useRef();


    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/order-set/view/${id}`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setData(data.data);
                setSelectedPlatform(
                    data?.data?.platformTypeId != null ? String(data?.data?.platformTypeId) : ""
                );
            });
    }, [updateData]);

    const [platformTypeData, setPlatformTypeData] = useState([]);
    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/platform-type/all/view`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setPlatformTypeData(data.data);
            });
    }, []);


    const handleSubmitData = (event) => {
        event.preventDefault();
        refSubmitDis.current.setAttribute("disabled", true);
        setErrorMessage({});
        try {
            const formData = new FormData(event.currentTarget);
            const config = {
                headers: {
                    "content-type": "application/json",
                },
            };
            axios
                .put(
                    `https://api.velormall.com/api/admin/order-set/update/${id}`,
                    formData,
                    config
                )
                .then((response) => {
                    event.target.reset();
                    toast.success(`${response?.data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    setupdateData(response?.data);
                    refSubmitDis.current.removeAttribute("disabled");
                })
                .catch((error) => {
                    setErrorMessage(error?.response?.data?.errors)
                    refSubmitDis.current.removeAttribute("disabled");
                });

        } catch (error) {

        }
    };



    return (
        <>
            <div className="d-flex  flex-wrap gap-3 justify-content-between align-items-center">
                <h6 className="page-title">Order Set Edit</h6>
                <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins"></div>
            </div>
            <div className="row">
                <div className="col-lg-12 col-md-12 mb-5">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSubmitData}>
                                <div className="row align-items-center">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="heading" className="required">
                                                Name
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                name="name"
                                                placeholder="Name"
                                                id="heading"
                                                defaultValue={data?.name}
                                            />

                                            <div style={{ minHeight: "22px" }}>
                                                {errorMessage?.name && (
                                                    <span className="text-danger">
                                                        {errorMessage.name.msg}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="role" className="required">
                                                Platform
                                            </label>

                                            <select
                                                className="form-control"
                                                name="platformTypeId"
                                                id="role"
                                                value={selectedPlatform}
                                                onChange={(e) =>
                                                    setSelectedPlatform(e.target.value)
                                                }
                                            >
                                                <option value="" disabled>
                                                    Select Platform
                                                </option>

                                                {platformTypeData.map((item) => (
                                                    <option
                                                        key={item?._id}
                                                        value={item?._id}
                                                    >
                                                        {item?.name}
                                                    </option>
                                                ))}
                                            </select>

                                            <div style={{ minHeight: "22px" }}>
                                                {errorMessage?.platformTypeId && (
                                                    <span className="text-danger">
                                                        {errorMessage.platformTypeId.msg}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <button
                                                ref={refSubmitDis}
                                                type="submit"
                                                className="btn btn-primary w-100 h-45"
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <OrderList PlatformData={data} />
        </>
    );
};

export default OrderSetEdit;
